/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import * as yup from 'yup';
import map from 'lodash/map';

import { message } from 'antd';
import BillingInfo from './BillingInfo';
import { Layout } from '../../Common/Component';
import {CheckCircleOutlined} from '@ant-design/icons';
import InvoiceSummary from '../Component/InvoiceSummary';
import CreditCard from '../../Common/Component/CreditCard';
import BankAccountDetails from '../../Common/Component/BankAccountDetails';
import AcceptedCards from '../../../Assets/images/credit-cards.png'
import BankAccount from '../../../Assets/images/BankAccountImage.svg';
import { Collapse } from 'antd';

class Pay extends Component {
	fattJs = null;

	constructor(props) {
	  super(props);
	  this.state = {
	    total: 0,
	    errors: {},
	    address: {},
	    pay_info: {},
	    sales_tax: 0,
	    loader: false,
	    balance_due: 0,
	    invoice_uuid: '',
	    stax_customer: '',
	    previous_balance: 0,
	    show_success: false,
	    stax_card_token: '',
	    credit_card_info: {},
	    bank_account_info: {},
	    stax_public_apikey: '',
	    is_button_disable: false,
	    checked_permissions: true,
	    checked_permissions_ach: true,
	    total_paid: 0,
	    displayCard: false,
	    displayBank: true,
	  };

	}

	//ComponentDidMount
	componentDidMount = () => {
		// From link to doody-fe pay
		if (this.props?.location?.search && this.props?.location?.search.includes("?")) 
		{
			let encoded = this.props?.location?.search?.split("?")[1];
		
			// Decode 
			const decoded_string = window.atob(encoded);
		
			let search_params = decoded_string.split("&");
			let temp_stax_public_apikey, temp_invoice_uuid, temp_stax_customer;
			let temp_total = 0;
			let temp_taxes = 0;
			let temp_balance_due = 0;
			let temp_total_paid = 0;
	  
	    map(search_params, (search_param) => {
			  let key = search_param.split("=")[0];
			  let value = search_param.split("=")[1];


			  if (key === "stax_public_apikey"){
	        temp_stax_public_apikey = value;
			  } 
			  if (key === "total" && value !== '0') {
	        temp_total = parseFloat(value);
			  }
			  if (key === "taxes" && value !== '0' ) {
	        temp_taxes = parseFloat(value);
			  }
			  if (key === "invoice_uuid") {
	        temp_invoice_uuid = value;
			  }
			  if (key === "stax_customer") {
	        temp_stax_customer = value;
			  }
			  if (key === "balance_due") {
	        temp_balance_due = parseFloat(value);
			  }
			  if (key === "total_paid") {
	        temp_total_paid = parseFloat(value);
			  }
			});
		
			this.setState({
				total: temp_total,
				sales_tax: temp_taxes,
				invoice_uuid: temp_invoice_uuid,
				stax_customer: temp_stax_customer,
				previous_balance: temp_balance_due &&  temp_balance_due - temp_total - temp_taxes + temp_total_paid,
				stax_public_apikey: temp_stax_public_apikey,
				balance_due: temp_balance_due !== 0 ? temp_balance_due : temp_total + temp_taxes - temp_total_paid,
				total_paid: temp_total_paid
			});
		}
	}

	 //UNSAFE_componentWillMount
	 UNSAFE_componentWillReceiveProps = (props) => {
		
	   if(props?.paymentLink && Object.keys(props.paymentLink).length > 0 &&
			props.paymentLink !== this.props.paymentLink)
	   {
	     this.setState({loader: false, is_button_disable: true, show_success: true});
	     message.success(props?.paymentLink?.message);
	   }
	
	   if (props?.error && Object.keys(props?.error).length > 0 &&
			props.error !== this.props.error) {
		  
	     message.error(props.error);
	   }
	  
	   this.setState({ loader: false });
	 }

	// Address validation
	validate = () => {
	  var self = this;
	  const {
		  address,
		  balance_due,
		  invoice_uuid,
		  stax_customer,
		  credit_card_info,
		  bank_account_info,
		  checked_permissions,
		  checked_permissions_ach,
	  } = this.state;

	  this.setState({ loader: true, errors: {} });

	  if(this.state.displayBank)
	  {

		  setTimeout(() => 
		  {
			  const schema = yup.object().shape({
				  address: yup.object().shape({
				  address: yup.string().required("Address is required"),
				  state: yup.string().required("State is required"),
				  city: yup.string().required("City is required"),
				  first_name: yup.string().required("First name is required"),
				  last_name: yup.string().required("Last name is required"),
				  zip_code: yup.string().required("Zipcode is required")
					  .min(5, 'Your ZIP code is invalid.')
					  .max(5, 'Your ZIP code is invalid.'),
				  }),
				  bank_account_info: yup.object().shape({
				  ach_bank_account_name: yup.string().required("Please enter correct value !"),
				  ach_routing_number: yup
					  .string()
					  .required("Please enter correct value !")
					  .min(9, "Total number of digits should be 9")
					  .max(9, "Total number of digits should be 9"),
				  ach_account_number: yup
					  .string()
					  .nullable()
					  .required("Please enter correct value !")
					  .max(15, "Length should not greater than 15"),
				  ach_account_type: yup.string().required("Please enter correct value !"),
				  ach_bank_holder_type: yup.string().required("Please enter correct value !"),
				  })
			  });	 
	  
			  const credit_card_data = { address, credit_card_info };
			  const ach_bank_account_data = { address,  bank_account_info };
			  const err_data = {};
  
			  schema.validate(ach_bank_account_data, { abortEarly: false }).then(() => 
			  {
				  const token_obj = {
					  address_1 : address.address,
					  address_city : address.city,
					  address_state : address.state,
					  address_zip : address.zip_code,
					  bank_account: bank_account_info.ach_account_number,
						  bank_routing: bank_account_info.ach_routing_number,
						  bank_holder_type: bank_account_info.ach_bank_holder_type || "",
						  bank_type: bank_account_info.ach_account_type || "",
					  firstname : address.first_name,
					  lastname : address.last_name,
					  method : "bank",
					  customer_id: stax_customer,
					  person_name : address.first_name + ' ' + address.last_name,
					  check_of : 'checked',
				  };
  
				  this.fattJs.tokenize(token_obj).then((res) => {
					  if (res && Object.keys(res).length > 0) {
						  let params = {
						  total: balance_due,
						  invoice_uuid,
						  stax_card_token: res['id'],
						  "stax_customer": stax_customer,
						  "save_card":checked_permissions_ach,
						  "card_holder_name": token_obj.person_name,
						  "address":{
							  "address": address.address,
							  "address2":null,
							  "city": address.city,
							  "state": address.state,
							  "zip_code": address.zip_code,
							  "formatted_address": `${address.address}, ${address.city}, ${address.state}., ${address.zip_code}`
						  },
						  "payment_method" : "ach"
						  };
  
						  this.props.linkPayment(params);
					  } else {
						  this.setState({ loader : false });
					  }
				  });
			  }).catch( function (err) {
				  map(err.inner, (item) => {
						  err_data[item.path] = item.message;
				  });
  
				  console.log(err);
				  self.setState({ errors: err_data, loader: false });
					  }
			  );
		  }, 500);
	  }

	  else
	  {
	    setTimeout(() => {
	    	const schema = yup.object().shape({
	          address: yup.object().shape({
	            address: yup.string().required("Address is required"),
	            state: yup.string().required("State is required"),
	            city: yup.string().required("City is required"),
				first_name: yup.string().required("First name is required"),
				last_name: yup.string().required("Last name is required"),
	            zip_code: yup.string().required("Zipcode is required")
	              .min(5, 'Your ZIP code is invalid.')
	              .max(5, 'Your ZIP code is invalid.'),
				}),
				credit_card_info: yup.object().shape({
					card_number : this.fattJs.validNumber ? null : yup.string().nullable().required('Card Number is required'),
					card_expiry_month : yup.string().nullable().required('Expire Month is required'),
					card_expiry_year : yup.string().nullable().required('Expire Year is required')
							.min(4, 'Card expire year is invalid.')
							.max(4, 'Card expire year is invalid.'),
					card_cvv : this.fattJs.validCvv ? null : yup.string().nullable().required('CVV is required'),
				}),
			});	 
  
	        const credit_card_data = { address, credit_card_info };
	        const ach_bank_account_data = { address,  bank_account_info };
	  		const err_data = {};

			schema.validate(credit_card_data, { abortEarly: false }).then(() => 
			{
	        	const token_obj = {
					address_1 : address.address,
					address_city : address.city,
					address_state : address.state,
					address_zip : address.zip_code,
					month : credit_card_info.card_expiry_month,
					year : credit_card_info.card_expiry_year,
					card_number : credit_card_info.card_number,
					firstname : address.first_name,
					lastname : address.last_name,
					method : 'card',
					customer_id: stax_customer,
					person_name : address.first_name + ' ' + address.last_name,
					check_of : 'checked',
				};

	          	this.fattJs.tokenize(token_obj).then((res) => {
					if (res && Object.keys(res).length > 0) {
						let params = {
							total: balance_due,
							invoice_uuid,
							stax_card_token: res['id'],
							"stax_customer": stax_customer,
							"save_card":checked_permissions,
							"card_holder_name": token_obj.person_name,
							"address":{
								"address": address.address,
								"address2":null,
								"city": address.city,
								"state": address.state,
								"zip_code": address.zip_code,
								"formatted_address": `${address.address}, ${address.city}, ${address.state}., ${address.zip_code}`
							}
						}

						this.props.linkPayment(params);
					}
					else {
						this.setState({ loader : false });
					}
	          	});
	  		}).catch(
				function (err) {
					map(err.inner, (item) => { err_data[item.path] = item.message; });

					console.log(err);
		  			self.setState({ errors: err_data, loader: false });
			  	}
	  		);
	    }, 500)
	  }
	}

	// On address change
	onAddressChange = (e) => {
	  const {address} = this.state;

	  Object.assign(address, {[e.target.name]: e.target.value});
	  this.setState({address});
	}

	// On credit card info change
	onCreditCardInfoChange = (e) => {
	  const {credit_card_info} = this.state;
		
	  Object.assign(credit_card_info, {[Object.keys(e)[0]]: e[Object.keys(e)[0]]});
	  this.setState({credit_card_info});
	}

	onBankCardInfoChange = (e) => {
	  const {bank_account_info} = this.state;
	  Object.assign(bank_account_info, {[Object.keys(e)[0]]: e[Object.keys(e)[0]]});
	  this.setState({bank_account_info});

	}

	onChangeCheckbox = (checked) => {
	  this.setState({checked_permissions: checked});
	}

	onChangeBankDetailsCheckbox = (checked) => {
	  this.setState({checked_permissions_ach: checked});
	  }

	setFattJs = (param) => {
	  this.fattJs = param;
	}

	renderSuccess = () => {
	  return <React.Fragment>
	    <div className="col-md-12 col-lg-5 card pay_container">
	      <CheckCircleOutlined style={{ fontSize: '70px', height: "35px"}} />
	      <h1>Thank you for your payment</h1>
	    </div>
	  </React.Fragment>
	}

	creditcardclicked = () => {

	  this.setState({displayCard: true})
	  this.setState({displayBank: false})
	}

	bankaccountclicked = () => {
	  this.setState({displayBank: true})
	  this.setState({displayCard: false})
	}

	renderForm = () => {
	  const {
	    total,
	    sales_tax,
	    balance_due,
	    previous_balance,
	    is_button_disable,
	    total_paid
	  } = this.state;
	  const stax_public_apikey = this.state.stax_public_apikey;

	  return <div className="card pay_container col-lg-5 col-md-12">
	    <InvoiceSummary
	      total = {total}
	      sales_tax = {sales_tax}
	      balance_due = {balance_due}
	      previous_balance = {previous_balance}
	      total_paid ={total_paid}
	    ></InvoiceSummary>
	    <div className="flex-1" style={{margin: "18px 0", alignSelf: "flex-start"}}>
	      <h2 className="mb-0" style={{color: "#297c78"}}>Payment Method</h2>
	      <p>Accounts are charged at the beginning of each month for service provided the prior month</p>
	      <hr></hr>
	    </div>
	    {/* <div className='add_radio'> */}
	    <div className='payment-section' style={{ border: '1px solid #DCDCE6',
	        borderRadius: '8px', padding: '8px 19px 18px 10px', width: '100%', marginBottom: '18px'}}>
	    <div 
	      onChange={this.bankaccountclicked}
	      className="half_size_items"
	      style={{
	        justifyContent: "space-between",
	        flexFlow: "row",
	        display: "flex",
	        width: "100%",
	       
	      }}>
	      <div className='radio-heading_bank_details' style={{marginBottom: '10px'}}>
	        <input type="radio" value="displayBank" name="bank_details" checked={this.state.displayBank} style={{marginRight: '15px'}}/>
	        <h4 className="mb-0" style={{color: "#297c78"}}>Bank Account</h4>
	      </div>
	      <img src={BankAccount} alt = {"No image Found"} style={{width: "200px", height: "20px", display: "flex"}}></img>

	    </div>
	      <hr style={{margin: '0px' , width: '100%'}}/>
	    { this.state.displayBank && this.state.stax_public_apikey && 
		<BankAccountDetails 
		  onBankCardInfoChange={this.onBankCardInfoChange}
		  setFattJs={this.setFattJs}
	      onChangeBankDetailsCheckbox={this.onChangeBankDetailsCheckbox}
		  {...this.state}
	  ></BankAccountDetails> }
	  </div>
	    
	  <div className='payment-section' style={{ border: '1px solid #DCDCE6',
	        borderRadius: '8px', padding: '8px 19px 18px 10px', width: '100%'}}>

	    <div 
	      onChange={this.creditcardclicked}
	      className="half_size_items"
	      style={{
	        justifyContent: "space-between",
	        flexFlow: "row",
	        display: "flex",
	        width: "100%",
	        // backgroundColor: 'red',
	        margin: '10px 0 0 0 ',
	      }}>
	      <div className='radio-heading_credit_card_details'>
	        <input type="radio" value="displayCard" name="credit_card" 
	          style={{marginRight: '15px'}}
	          checked = {this.state.displayCard}
	          // disabled= {!this.state.displayCard}
	        />
	        <h4 className="mb-0" style={{color: "#297c78"}}>Credit Card</h4>
	      </div>
	      <img src={AcceptedCards} alt = {"No image found"} style={{width: "200px", display: "flex"}}></img>
	    </div>
	      <hr style={{margin: '0px' , width: '100%'}}/>
	    {/* </div> */}
	    {this.state.displayCard && this.state.stax_public_apikey && (
	      <CreditCard
	        setFattJs={this.setFattJs}
	        onCreditCardInfoChange={this.onCreditCardInfoChange}
	        onChangeCheckbox={this.onChangeCheckbox}
	        {...this.state}
	      />
	    )}
	    </div>
	    
	    {/* } */}

	    <div className="flex-1" style={{margin: "18px 0", alignSelf: "flex-start"}}>
	      <h2 className="mb-0" style={{color: "#297c78"}}>Billing Address</h2>
	      <hr style={{width: "820px"}}></hr>
	    </div>

	    <BillingInfo
	      onAddressChange={this.onAddressChange}
	      {...this.state}
	    ></BillingInfo>

	    <button 
	      type="button"
	      disabled={is_button_disable}
	      onClick={this.validate}
	      className="btn btn--secondary pay-button"
	    >
				Make Payment
	    </button>
	  </div>
	}

	render() 
	
	{
	  const {
	    loader,
	    show_success,
	  } = this.state;

	  return (
	    <Layout
			 hideLinks={true}
	    >
	      { 
	        show_success ? this.renderSuccess() : this.renderForm()
	      }
	      {
	        loader ?
	          <div className='loader_wrapper'>
	            < div className='loader07' ></div >
	          </div >
	          : ''
	      }

	    </Layout>
	  );
	}
}

export default Pay;